import React from 'react'

import useSingleOrganization from '../../../hooks/useSingleOrganization'

export default function OrganizationLocation() {
    const {singleOrganizationQuery} = useSingleOrganization()

    if (singleOrganizationQuery.isLoading) return <>...</> 
    if (singleOrganizationQuery.isError) return <>-</>
    if (!singleOrganizationQuery.data) return <></>
    const data = singleOrganizationQuery.data
    const location  = [data?.organization_city, data?.organization_country].filter(Boolean).join(', ')
   return (
    <>
      {location}
    </>
  )
}
